import {
  DiMaDetailsContent,
  DiMaDetailsContentProps,
} from "../../../../components/DiMaDetailsContent"
import {
  AccessLevel,
  DimaFeatureShortNameEnum,
  hasUserAccessToApplicationFeature,
} from "../../../../models/Authorization"
import { GatewayManufacturedDeviceInfo } from "../../../../models/Gateway"
import { UserInfo } from "../../../../models/User"

export function GatewaysManufacturedDeviceDetails(props: {
  readonly device: GatewayManufacturedDeviceInfo
  readonly user: UserInfo
}) {
  const { device, user } = props

  const listItems = [
    {
      id: 0,
      label: "Part Number",
      displayItem: <div>{device.partNumber}</div>,
    },
    {
      id: 1,
      label: "Serial Number",
      displayItem: <div>{device.serialNumber}</div>,
    },
    {
      id: 2,
      label: "Mac Address Eth0",
      displayItem: <div>{device.macAddressEth0}</div>,
    },
    {
      id: 3,
      label: "Mac Address Eth1",
      displayItem: <div>{device.macAddressEth1}</div>,
    },
    {
      id: 4,
      label: "Mac Address Wlan0",
      displayItem: <div>{device.macAddressWlan0}</div>,
    },
    {
      id: 5,
      label: "Construction Date",
      displayItem: <div>{device.constructionDate}</div>,
    },
    { id: 6, label: "Additional Info", displayItem: <div>{device.additionalInfo}</div> },
    { id: 7, label: "Activation Code", displayItem: <div>{device.activationCode}</div> },
    {
      id: 8,
      label: "Modified By",
      displayItem: <div>{device.modifiedBy}</div>,
    },
    { id: 9, label: "Purchase Order", displayItem: <div>{device.purchaseOrder}</div> },
    { id: 10, label: "Device ID", displayItem: <div>{device.deviceId}</div> },
    { id: 11, label: "Enrollment Code", displayItem: <div>{device.enrollmentCode}</div> },
    { id: 12, label: "IMEI Number", displayItem: <div>{device.imeiNumber}</div> },
    { id: 13, label: "Image Version", displayItem: <div>{device.imageVersion}</div> },
    {
      id: 14,
      label: "Env File Version",
      displayItem: <div>{device.envFileVersion}</div>,
    },
    {
      id: 15,
      label: "DPCM File Version",
      displayItem: <div>{device.dpcmFileVersion}</div>,
    },
    { id: 16, label: "Ability IDP ID", displayItem: <div>{device.abilityIdpId}</div> },
    { id: 17, label: "GW Token", displayItem: <div>{device.gwToken}</div> },
    { id: 18, label: "PKI Profile", displayItem: <div>{device.pkiProfile}</div> },
    {
      id: 19,
      label: "Certificate Expire Date",
      displayItem: <div>{device.certificateExpireDate}</div>,
    },
    { id: 20, label: "Type", displayItem: <div>{device.type}</div> },
    { id: 21, label: "GW Log Password", displayItem: <div>{device.gwLogPassword}</div> },
  ]

  const detailsContentProps: DiMaDetailsContentProps<GatewayManufacturedDeviceInfo> = {
    canWrite: hasUserAccessToApplicationFeature(
      user.authorizations.applications,
      device.id,
      DimaFeatureShortNameEnum.GW,
      AccessLevel.Write
    ),
    inlineEdit: false,
    listItems,
  }

  return <DiMaDetailsContent {...detailsContentProps} />
}
